import { render, staticRenderFns } from "./TesteSocketIO.vue?vue&type=template&id=09c2ca79&"
import script from "./TesteSocketIO.vue?vue&type=script&lang=js&"
export * from "./TesteSocketIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports